import React from 'react';
import { Link } from 'react-router-dom';
import { Check, GitCompareArrows } from 'lucide-react';
import { KitImage } from './ui/KitImage';
import { OrderButton } from './ui/OrderButton';
import { brandImages } from '../data/brandImages';
import { priceLabel } from '../data/mockData';
import { collectionLabel, panelPath } from '../data/serviceContent';

export const PanelCard = ({ panel, selected, compareFull, onCompare }) => (
  <article className={`hbk-panel-card ${selected ? 'is-selected' : ''}`} data-testid={`product-card-${panel.id}`}>
    <div className="hbk-panel-summary">
      <h3 className="hbk-panel-title"><Link to={panelPath(panel)} data-testid={`product-name-${panel.id}`}>{panel.name}</Link></h3>
      <Link to={panelPath(panel)} className="hbk-panel-image" aria-label={`View ${panel.name} details`} data-testid={`product-image-button-${panel.id}`}>
        <KitImage image={brandImages.box} testId={`product-image-${panel.id}`} />
      </Link>
      <p className="hbk-panel-purpose hbk-copy-main mt-2 text-[#2a3950]" data-testid={`product-purpose-${panel.id}`}>{panel.tagline}</p>
    </div>
    <div className="hbk-panel-body">
      <p className="font-heading font-bold text-2xl" data-testid={`product-price-${panel.id}`}>{priceLabel(panel)}</p>
      <p className="text-sm text-[#2a3950] my-3" data-testid={`product-reddrop-${panel.id}`}>{collectionLabel(panel)}</p>
      <OrderButton panelId={panel.id} testId={`buy-btn-${panel.id}`}>Is This the Right Panel for You?</OrderButton>
      <div className="flex flex-wrap items-center justify-between gap-2 mt-2">
        <Link to={panelPath(panel)} className="hbk-text-link text-sm" data-testid={`product-details-${panel.id}`}>View Panel Details</Link>
        <button type="button" aria-pressed={selected} aria-label={`${selected ? 'Remove' : 'Add'} ${panel.name} ${selected ? 'from' : 'to'} comparison`} disabled={!selected && compareFull} onClick={() => onCompare(panel.id)} className="hbk-compare-toggle" data-testid={`compare-toggle-${panel.id}`}>
          {selected ? <Check size={17} aria-hidden="true" /> : <GitCompareArrows size={17} aria-hidden="true" />} {selected ? 'Selected' : 'Compare'}
        </button>
      </div>
      <details className="border-t border-[var(--line)] mt-2" data-testid={`product-expanded-${panel.id}`}>
        <summary className="hbk-detail-summary" data-testid={`product-expand-${panel.id}`}>Who This Is For and Listed Tests</summary>
        <p className="hbk-copy-main mb-3" data-testid={`product-bestfor-${panel.id}`}>{panel.bestFor}</p>
        <p className="hbk-copy-main mb-3" data-testid={`product-tests-${panel.id}`}>{panel.biomarkers.length} listed tests / marker groups: {panel.biomarkers.join(', ')}.</p>
        <p className="text-sm mb-4" data-testid={`product-customization-note-${panel.id}`}>A starting preference only. The team confirms your final testing after intake.</p>
      </details>
    </div>
  </article>
);